<template>
  <div class="sh-ri content-main">
    <pulse-loader
      :loading="loading"
      :color="color"
      :size="size"
      class="vue-loader"
    ></pulse-loader>
    <div class="sh-ri-content">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-title-index">
              <h2>
                Ranking Resultado Previne Brasil
                <span
                  v-b-tooltip.hover
                  title="Considera-se apenas equipes (eAP e eSF) válidas para o componente de desempenho"
                  class="icon-tooltip"
                >
                  <i class="icofont-info-circle" style="font-size: 20px"></i>
                </span>
              </h2>
            </div>
          </div>
          <div class="col-lg-3 col-md-12">
            <div class="form-group">
              <select
                id="quadrimestre"
                name="quadrimestre"
                v-model="quadrimestre"
                class="form-control"
                @change="buscarPorQuadrimestre($event)"
              >
                <option value="" disabled>Quadrimestre</option>
                <option v-for="(item, index) in quadrimestres" :key="index">
                  {{ item.quadrimestre }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-lg-3 col-md-12">
            <div class="form-group">
              <select
                id="estado"
                name="estado"
                v-model="estado"
                class="form-control"
                @change="buscarPorEstado($event)"
              >
                <option value="" disabled>Estado</option>
                <option value="AC">Acre</option>
                <option value="AL">Alagoas</option>
                <option value="AP">Amapá</option>
                <option value="AM">Amazonas</option>
                <option value="BA">Bahia</option>
                <option value="CE">Ceará</option>
                <option value="DF">Distrito Federal</option>
                <option value="ES">Espírito Santo</option>
                <option value="GO">Goiás</option>
                <option value="MA">Maranhão</option>
                <option value="MT">Mato Grosso</option>
                <option value="MS">Mato Grosso do Sul</option>
                <option value="MG">Minas Gerais</option>
                <option value="PA">Pará</option>
                <option value="PB">Paraíba</option>
                <option value="PR">Paraná</option>
                <option value="PE">Pernambuco</option>
                <option value="PI">Piauí</option>
                <option value="RJ">Rio de Janeiro</option>
                <option value="RN">Rio Grande do Norte</option>
                <option value="RS">Rio Grande do Sul</option>
                <option value="RO">Rondônia</option>
                <option value="RR">Roraima</option>
                <option value="SC">Santa Catarina</option>
                <option value="SP">São Paulo</option>
                <option value="SE">Sergipe</option>
                <option value="TO">Tocantins</option>
              </select>
            </div>
          </div>
          <div class="col-lg-2">
            <button class="btn" @click="resetarFiltros()">Limpar</button>
          </div>
          <div class="col-lg-4">
            <div class="pdf-container">
              <b-spinner
                v-if="loadingPdf"
                class="spinner"
                label="Spinning"
              ></b-spinner>
              <button class="btn float-right" @click="gerarPdf()">
                <i class="icofont-print"></i>
                PDF
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="sh-ri-info">
              <h3>{{ info.title }}</h3>
              <div class="sh-ri-percent" v-if="info.type == 'pre-natal'">
                <div class="sh-ri-percent-red"><span></span> < 18%</div>
                <div class="sh-ri-percent-orange">
                  <span></span> >= 18% e < 31%
                </div>
                <div class="sh-ri-percent-green">
                  <span></span> >= 31% e < 45%
                </div>
                <div class="sh-ri-percent-blue"><span></span> >= 45%</div>
              </div>
              <div
                class="sh-ri-percent"
                v-if="
                  info.type == 'hiv-sifilis' ||
                  info.type == 'consultas-odontologicas'
                "
              >
                <div class="sh-ri-percent-red"><span></span> < 24%</div>
                <div class="sh-ri-percent-orange">
                  <span></span> >= 24% e < 42%
                </div>
                <div class="sh-ri-percent-green">
                  <span></span> >= 42% e < 60%
                </div>
                <div class="sh-ri-percent-blue"><span></span> >= 60%</div>
              </div>
              <div class="sh-ri-percent" v-if="info.type == 'citopatologico'">
                <div class="sh-ri-percent-red"><span></span> < 16%</div>
                <div class="sh-ri-percent-orange">
                  <span></span> >= 16% e < 28%
                </div>
                <div class="sh-ri-percent-green">
                  <span></span> >= 28% e < 40%
                </div>
                <div class="sh-ri-percent-blue"><span></span> >= 40%</div>
              </div>
              <div class="sh-ri-percent" v-if="info.type == 'polio-penta'">
                <div class="sh-ri-percent-red"><span></span> < 38%</div>
                <div class="sh-ri-percent-orange">
                  <span></span> >= 38% e < 67%
                </div>
                <div class="sh-ri-percent-green">
                  <span></span> >= 67% e < 95%
                </div>
                <div class="sh-ri-percent-blue"><span></span> >= 95%</div>
              </div>
              <div
                class="sh-ri-percent"
                v-if="
                  info.type == 'hipertensao' ||
                  info.type == 'hemoglobina-glicada'
                "
              >
                <div class="sh-ri-percent-red"><span></span> < 20%</div>
                <div class="sh-ri-percent-orange">
                  <span></span> >= 20% e < 35%
                </div>
                <div class="sh-ri-percent-green">
                  <span></span> >= 35% e < 50%
                </div>
                <div class="sh-ri-percent-blue"><span></span> >= 50%</div>
              </div>
              <div class="sh-ri-percent" v-if="info.type == 'isf'">
                <div class="sh-ri-percent-red"><span></span> < 4.0</div>
                <div class="sh-ri-percent-orange">
                  <span></span> >= 4.0 e < 7.0
                </div>
                <div class="sh-ri-percent-green">
                  <span></span> >= 7.0 e <= 9.0
                </div>
                <div class="sh-ri-percent-blue"><span></span> > 9.0</div>
              </div>
              <div class="sh-ri-percent" v-if="info.type == 'desempenho'">
                <!-- <div class="sh-ri-percent-red">
                                    <span></span> < 40%
                                </div>
                                <div class="sh-ri-percent-orange">
                                    <span></span> >= 40% e < 70%
                                </div>
                                <div class="sh-ri-percent-green">
                                    <span></span> >= 70% e <= 90%
                                </div>
                                <div class="sh-ri-percent-blue">
                                    <span></span> > 90%
                                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="box" style="margin-top: 10px">
          <table class="table table-responsive table-striped" id="table">
            <thead class="thead-light fixed-header">
              <tr>
                <th>TEM</th>
                <!-- <th @mouseover="updateInfo('serie-historica')">
                  S. H.
                </th>
                <th @mouseover="updateInfo('selo-aps')">
                  Selo
                </th> -->
                <!-- <th @mouseover="updateInfo('desempenho')">
                  %
                </th> -->
                <th class="text-left" @mouseover="updateInfo('municipio')">
                  MUNICÍPIO
                </th>
                <th @mouseover="updateInfo('pre-natal')">I1</th>
                <th @mouseover="updateInfo('hiv-sifilis')">I2</th>
                <th @mouseover="updateInfo('consultas-odontologicas')">I3</th>
                <th @mouseover="updateInfo('citopatologico')">I4</th>
                <th @mouseover="updateInfo('polio-penta')">I5</th>
                <th @mouseover="updateInfo('hipertensao')">I6</th>
                <th @mouseover="updateInfo('hemoglobina-glicada')">I7</th>
                <th @mouseover="updateInfo('isf')">ISF</th>
                <th @mouseover="updateInfo('desempenho')">DESEMPENHO</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in displayedCadastros" :key="index">
                <td v-if="item.status != null && item.status == 1">
                  <a href="https://esusfeedback.com.br/" target="_blank">
                    <img
                      src="@/assets/images/logo-mini.png"
                      alt=""
                      style="width: 40px"
                    />
                  </a>
                </td>
                <td v-else>
                  <a href="https://esusfeedback.com.br/" target="_blank">
                    <img
                      src="@/assets/images/logo-feedback-black.png"
                      alt=""
                      style="width: 40px"
                    />
                  </a>
                </td>
                <!-- <td class="rh-si-icon-grafico">
                  <div class="rh-si-btn">
                    <img
                      src="@/assets/images/graph-icon.png"
                      @click="showModal(item)"
                    />
                  </div>
                </td>
                <td v-if="item.isf >= 7">
                  <img
                    src="@/assets/images/LOGO-APS-COLORIDA.png"
                    alt=""
                    @click="modalSeloAps(item, index + 1)"
                    class="selo-aps-img"
                  />
                </td>
                <td v-else>
                  <img
                    src="@/assets/images/LOGO-APS-PRETO-E-BRANCO.png"
                    alt=""
                    @click="modalSeloAps(item, index + 1)"
                    class="selo-aps-img"
                  />
                </td> -->
                <!-- <td
                  v-bind:class="changeFontColor(parseFloat(item.isf))"
                  class="font-weight-bold"
                  @click="modalPorcentagem(item)"
                  style="cursor:pointer"
                >
                  {{ (item.isf * 10).toFixed(2) }}
                </td> -->
                <!-- nome municipio -->
                <td class="text-left btn-options">
                  <b-dropdown dropright no-caret>
                    <template #button-content>
                      <i class="icofont-navigation-menu"></i>
                    </template>
                    <b-dropdown-item @click="showModal(item)"
                      >Gráfico Indicadores</b-dropdown-item
                    >
                    <b-dropdown-item @click="showModalIsf(item)"
                      >Gráfico ISF</b-dropdown-item
                    >
                    <b-dropdown-item @click="modalSeloAps(item, index + 1)"
                      >Desempenho</b-dropdown-item
                    >
                    <b-dropdown-item @click="modalPorcentagem(item)"
                      >Evolução</b-dropdown-item
                    >
                  </b-dropdown>
                  <div class="placement" v-if="nomeMunicipio == ''">
                    <span v-bind:class="changeFontColor(parseFloat(item.isf))"
                      >{{ index + 1 }}°</span
                    >
                    {{ item.municipio }} - {{ item.uf }}
                  </div>
                </td>
                <td
                  v-bind:class="
                    indicadorColor(item.pn_6_consultas, 'pre-natal')
                  "
                >
                  {{ item.pn_6_consultas }}
                </td>
                <td
                  v-bind:class="
                    indicadorColor(item.pn_hiv_sifilis, 'hiv-sifilis')
                  "
                >
                  {{ item.pn_hiv_sifilis }}
                </td>
                <td
                  v-bind:class="
                    indicadorColor(
                      item.pn_odontologia,
                      'consultas-odontologicas'
                    )
                  "
                >
                  {{ item.pn_odontologia }}
                </td>
                <td
                  v-bind:class="
                    indicadorColor(item.citopatologico, 'citopatologico')
                  "
                >
                  {{ item.citopatologico }}
                </td>
                <td
                  v-bind:class="
                    indicadorColor(item.crianca_polio_penta, 'polio-penta')
                  "
                >
                  {{ item.crianca_polio_penta }}
                </td>
                <td
                  v-bind:class="
                    indicadorColor(item.pa_hipertensao, 'hipertensao')
                  "
                >
                  {{ item.pa_hipertensao }}
                </td>
                <td
                  v-bind:class="
                    indicadorColor(item.hg_diabetes, 'hemoglobina-glicada')
                  "
                >
                  {{ item.hg_diabetes }}
                </td>
                <td>
                  <div
                    class="sh-re-button-isf"
                    @click="showModalIsf(item)"
                    v-bind:class="changeFontColor(parseFloat(item.isf))"
                  >
                    {{ item.isf }}
                  </div>
                </td>
                <td>
                  {{ item.media }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- modal -->
      <div class="modal-sh" v-show="openedModal == true">
        <transition name="modal">
          <div class="modal-mask">
            <div class="modal-wrapper">
              <div class="modal-container">
                <div class="modal-header">
                  <slot name="header"> </slot>
                </div>
                <div class="modal-body">
                  <slot name="body">
                    <div class="row">
                      <div class="col-lg-12">
                        <apexchart
                          type="line"
                          height="480"
                          :options="chartOptions"
                          :series="chartData"
                          ref="chartData"
                        ></apexchart>
                      </div>
                      <div class="col-12">
                        <button
                          class="btn float-right"
                          @click="openedModal = false"
                        >
                          Fechar
                        </button>
                      </div>
                    </div>
                  </slot>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>

      <!-- modal -->
      <div class="modal-selo-aps" v-show="openedModalSeloAps == true">
        <transition name="modal">
          <div class="modal-mask">
            <div class="modal-wrapper">
              <div class="modal-container">
                <div class="modal-header">
                  <slot name="header"> </slot>
                </div>
                <div class="modal-body">
                  <slot name="body">
                    <div class="row">
                      <div class="col-lg-12">
                        <img :src="seloApsImg" alt="" />
                      </div>
                      <div class="col-12">
                        <div class="modal-selo-aps-footer">
                          <button
                            class="btn float-right mt-3"
                            @click="downloadSeloAps(seloApsImg)"
                          >
                            Baixar imagem
                          </button>
                          <button
                            class="btn float-right mt-3"
                            @click="openedModalSeloAps = false"
                          >
                            Fechar
                          </button>
                        </div>
                      </div>
                    </div>
                  </slot>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>

      <!-- modal -->
      <div class="modal-selo-aps" v-show="openedModalPorcentagem == true">
        <transition name="modal">
          <div class="modal-mask">
            <div class="modal-wrapper">
              <div class="modal-container">
                <div class="modal-header">
                  <slot name="header"> </slot>
                </div>
                <div class="modal-body">
                  <slot name="body">
                    <div class="row">
                      <div class="col-lg-12">
                        <img :src="porcentagemImg" alt="" />
                      </div>
                      <div class="col-12">
                        <div class="modal-selo-aps-footer">
                          <button
                            class="btn float-right mt-3"
                            @click="downloadImgPorcentagem(porcentagemImg)"
                          >
                            Baixar imagem
                          </button>
                          <button
                            class="btn float-right mt-3"
                            @click="openedModalPorcentagem = false"
                          >
                            Fechar
                          </button>
                        </div>
                      </div>
                    </div>
                  </slot>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <b-modal v-model="modalShow" size="lg" hide-footer>
      <iframe
        style="width: 100%; height: 500px"
        src="https://www.youtube.com/embed/BjrqQuv9zw0"
        title=""
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </b-modal>
  </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import VueApexCharts from 'vue-apexcharts'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'

export default {
  name: 'ListaResultados',
  metaInfo: {
    title: 'Ranking Resultado Previne Brasil',
    titleTemplate: null,
  },
  components: {
    PulseLoader,
    apexchart: VueApexCharts,
  },
  data() {
    return {
      loadingPdf: false,
      municipio: '',
      estado: '',
      quadrimestre: '',
      quadrimestres: [],
      dados: [],
      temEstadoSelecionado: false,
      nomeMunicipio: '',
      loading: false,
      size: '40px',
      color: '#0D98BB',
      info: {
        type: 'pre-natal',
        title:
          'Proporção de gestantes com pelo menos 6 (seis) consultas pré-natal realizadas, sendo a primeira até a 20ª semana de gestação',
      },
      openedModal: false,
      openedModalSeloAps: false,
      openedModalPorcentagem: false,
      seloApsImg: '',
      porcentagemImg: '',
      chartData: [],
      chartOptions: {
        chart: {
          height: 300,
          type: 'line',
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'straight',
          width: 2,
        },
        title: {
          text: '',
          align: 'center',
          style: {
            fontSize: '15px',
            fontWeight: 'bold',
            fontFamily: undefined,
            color: '#000',
          },
        },
        subtitle: {
          text: '',
          align: 'center',
          margin: 10,
          offsetX: 0,
          offsetY: 25,
          floating: false,
          style: {
            fontSize: '15px',
            fontWeight: 'bold',
            fontFamily: undefined,
            color: '#000',
          },
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
          // type: 'category'
        },
        yaxis: {
          min: 0,
          // max: 100
        },
        legend: {
          show: true,
          position: 'top',
          horizontalAlign: 'center',
        },
        markers: {
          size: 5,
        },
        colors: [
          '#008FFB',
          '#ff9933',
          '#FF0000',
          '#009933',
          '#ffff00',
          '#000000',
          '#ff33cc',
        ],
      },
      modalShow: false,
    }
  },
  computed: {
    displayedCadastros() {
      return this.dados
    },
  },
  mounted() {
    document.body.style.overflow = 'unset'
    this.buscarDados()
  },
  methods: {
    updateInfo(info) {
      switch (info) {
        case 'serie-historica':
          this.info.type = 'serie-historica'
          this.info.title =
            'Gráfico com a série histórica dos indicadores atuais.'
          break
        case 'selo-aps':
          this.info.type = 'selo-aps'
          this.info.title =
            'Municípios que tem tem ISF >= 7 recebem certificado de APS de qualidade.'
          break
        case 'municipio':
          this.info.type = 'municipio'
          this.info.title =
            'Os primeiros da lista são municípios com melhor desempenho, ou seja, ISF mais alto.'
          break
        case 'pre-natal':
          this.info.type = 'pre-natal'
          this.info.title =
            'Proporção de gestantes com pelo menos 6 (seis) consultas pré-natal realizadas, sendo a primeira até a 12ª semana de gestação.'
          break
        case 'hiv-sifilis':
          this.info.type = 'hiv-sifilis'
          this.info.title =
            'Proporção de gestantes com realização de exames para sífilis e HIV.'
          break
        case 'consultas-odontologicas':
          this.info.type = 'consultas-odontologicas'
          this.info.title =
            'Proporção de gestantes com atendimento odontológico realizado.'
          break
        case 'citopatologico':
          this.info.type = 'citopatologico'
          this.info.title = 'Cobertura de exame citopatológico.'
          break
        case 'polio-penta':
          this.info.type = 'polio-penta'
          this.info.title =
            'Proporção de crianças de 1 (um) ano de idade vacinadas na APS contra Difteria, Tétano, Coqueluche, Hepatite B, infecções causadas por Haemophilus Influenzae tipo b e Poliomielite Inativada.'
          break
        case 'hipertensao':
          this.info.type = 'hipertensao'
          this.info.title =
            'Percentual de pessoas hipertensas com Pressão Arterial aferida em cada semestre.'
          break
        case 'hemoglobina-glicada':
          this.info.type = 'hemoglobina-glicada'
          this.info.title =
            'Percentual de diabéticos com solicitação de hemoglobina.'
          break
        case 'isf':
          this.info.type = 'isf'
          this.info.title = 'Indicador Sintético Final.'
          break
        case 'desempenho':
          this.info.type = 'desempenho'
          this.info.title =
            'O desempenho é calculado pela média dos resultados individuais dos indicadores e ponderada pelos pesos de cada indicador multiplicada pelo ISF.'
          break
        default:
          break
      }
    },

    indicadorColor(valor, indicador) {
      const percentual = parseInt(valor)
      switch (indicador) {
        case 'pre-natal':
          if (percentual < 18) {
            return 'sh-ri-percent-red'
          } else if (percentual >= 18 && percentual < 31) {
            return 'sh-ri-percent-orange'
          } else if (percentual >= 31 && percentual < 45) {
            return 'sh-ri-percent-green'
          } else {
            return 'sh-ri-percent-blue'
          }
          break
        case 'hiv-sifilis':
          if (percentual < 24) {
            return 'sh-ri-percent-red'
          } else if (percentual >= 24 && percentual < 42) {
            return 'sh-ri-percent-orange'
          } else if (percentual >= 42 && percentual < 60) {
            return 'sh-ri-percent-green'
          } else {
            return 'sh-ri-percent-blue'
          }
          break
        case 'consultas-odontologicas':
          if (percentual < 24) {
            return 'sh-ri-percent-red'
          } else if (percentual >= 24 && percentual < 42) {
            return 'sh-ri-percent-orange'
          } else if (percentual >= 42 && percentual < 60) {
            return 'sh-ri-percent-green'
          } else {
            return 'sh-ri-percent-blue'
          }
          break
        case 'citopatologico':
          if (percentual < 16) {
            return 'sh-ri-percent-red'
          } else if (percentual >= 16 && percentual < 28) {
            return 'sh-ri-percent-orange'
          } else if (percentual >= 28 && percentual < 40) {
            return 'sh-ri-percent-green'
          } else {
            return 'sh-ri-percent-blue'
          }
          break
        case 'polio-penta':
          if (percentual < 38) {
            return 'sh-ri-percent-red'
          } else if (percentual >= 38 && percentual < 67) {
            return 'sh-ri-percent-orange'
          } else if (percentual >= 67 && percentual < 95) {
            return 'sh-ri-percent-green'
          } else {
            return 'sh-ri-percent-blue'
          }
          break
        case 'hipertensao':
          if (percentual < 20) {
            return 'sh-ri-percent-red'
          } else if (percentual >= 20 && percentual < 35) {
            return 'sh-ri-percent-orange'
          } else if (percentual >= 35 && percentual < 50) {
            return 'sh-ri-percent-green'
          } else {
            return 'sh-ri-percent-blue'
          }
          break
        case 'hemoglobina-glicada':
          if (percentual < 20) {
            return 'sh-ri-percent-red'
          } else if (percentual >= 20 && percentual < 35) {
            return 'sh-ri-percent-orange'
          } else if (percentual >= 35 && percentual < 50) {
            return 'sh-ri-percent-green'
          } else {
            return 'sh-ri-percent-blue'
          }
          break
        default:
          break
      }
    },

    async showModal(item) {
      this.$emit('closeMenu')
      this.openedModal = true
      this.municipio = item
      // limpa o gráfico inicialmente
      this.$refs.chartData.updateSeries([])
      try {
        let response = await this.$apiPublic.get(
          '/serie-historica/indicadores-previne-brasil/resultado/municipio/' +
            item.co_ibge
        )
        if (response) {
          let response2 = response.data
          let array_xaxis = []
          let array_chart_pre_natal = [],
            array_chart_hiv_sifilis = [],
            array_chart_consultas_odontologicas = [],
            array_chart_citologico = [],
            array_chart_imunizacao = [],
            array_chart_hipertensao = [],
            array_chart_hemoglobina = []

          //preencher a legenda
          for (const item of response2) {
            array_xaxis.push(item.quadrimestre)
          }

          for (let i = 0; i < array_xaxis.length; i++) {
            var eixo_x_atual = array_xaxis[i]
            for (const item of response2) {
              var resultado_pre_natal = 0
              var resultado_hiv_sifilis = 0
              var resultado_consultas_odontologicas = 0
              var resultado_citologico = 0
              var resultado_imunizacao = 0
              var resultado_hipertensao = 0
              var resultado_hemoglobina = 0
              if (item.quadrimestre == eixo_x_atual) {
                resultado_pre_natal = item.pn_6_consultas
                resultado_hiv_sifilis = item.pn_hiv_sifilis
                resultado_consultas_odontologicas = item.pn_odontologia
                resultado_citologico = item.citopatologico
                resultado_imunizacao = item.crianca_polio_penta
                resultado_hipertensao = item.pa_hipertensao
                resultado_hemoglobina = item.hg_diabetes
                break
              } else {
                resultado_pre_natal = null
                resultado_hiv_sifilis = null
                resultado_consultas_odontologicas = null
                resultado_citologico = null
                resultado_imunizacao = null
                resultado_hipertensao = null
                resultado_hemoglobina = null
              }
            }
            array_chart_pre_natal.push(resultado_pre_natal)
            array_chart_hiv_sifilis.push(resultado_hiv_sifilis)
            array_chart_consultas_odontologicas.push(
              resultado_consultas_odontologicas
            )
            array_chart_citologico.push(resultado_citologico)
            array_chart_imunizacao.push(resultado_imunizacao)
            array_chart_hipertensao.push(resultado_hipertensao)
            array_chart_hemoglobina.push(resultado_hemoglobina)
          }

          this.$refs.chartData.updateOptions({
            xaxis: {
              categories: array_xaxis,
            },
            title: {
              text: `${item.municipio} - ${item.uf}`,
            },
            subtitle: {
              text: `Indicadores do Previne Brasil. Fonte: eSUS Feedback, SISAB (${item.quadrimestre})`,
            },
            yaxis: {
              min: 0,
              max: 100,
            },
          })
          this.$refs.chartData.updateSeries([
            {
              name: 'Consultas pré-natal',
              data: array_chart_pre_natal,
            },
            {
              name: 'Exames HIV e Sífilis',
              data: array_chart_hiv_sifilis,
            },
            {
              name: 'Consultas odontológicas',
              data: array_chart_consultas_odontologicas,
            },
            {
              name: 'Citopatológico',
              data: array_chart_citologico,
            },
            {
              name: 'Vacinas',
              data: array_chart_imunizacao,
            },
            {
              name: 'Hipertensão',
              data: array_chart_hipertensao,
            },
            {
              name: 'Diabéticos',
              data: array_chart_hemoglobina,
            },
          ])
        }
      } catch (error) {
        console.log(error)
      }
    },

    async showModalIsf(item) {
      this.$emit('closeMenu')
      this.openedModal = true
      this.municipio = item
      // limpa o gráfico inicialmente
      this.$refs.chartData.updateSeries([])
      try {
        let response = await this.$apiPublic.get(
          '/serie-historica/indicadores-previne-brasil/resultado/municipio/' +
            item.co_ibge
        )
        if (response) {
          let response2 = response.data
          let array_xaxis = []
          let array_chart_isf = []

          //preencher a legenda
          for (const item of response2) {
            array_xaxis.push(item.quadrimestre)
          }

          for (let i = 0; i < array_xaxis.length; i++) {
            var eixo_x_atual = array_xaxis[i]
            for (const item of response2) {
              var resultado_isf = 0
              if (item.quadrimestre == eixo_x_atual) {
                resultado_isf = item.isf
                break
              } else {
                resultado_isf = null
              }
            }
            array_chart_isf.push(resultado_isf)
          }

          this.$refs.chartData.updateOptions({
            xaxis: {
              categories: array_xaxis,
            },
            title: {
              text: `${item.municipio} - ${item.uf}`,
            },
            subtitle: {
              text: `Indicador Sintético Final. Fonte: eSUS Feedback, SISAB (${item.quadrimestre})`,
            },
            yaxis: {
              min: 0,
              max: 10,
            },
          })
          this.$refs.chartData.updateSeries([
            {
              name: 'ISF',
              data: array_chart_isf,
            },
          ])
        }
      } catch (error) {
        console.log(error)
      }
    },

    async buscarDados() {
      try {
        this.loading = true

        let quadrimestres = await this.$apiPublic.get(
          '/serie-historica/indicadores-previne-brasil/quadrimestres'
        )
        if (quadrimestres) {
          this.quadrimestres = quadrimestres.data
          this.quadrimestre = quadrimestres.data[0].quadrimestre
        }
        let response = await this.$apiPublic.get(
          '/serie-historica/indicadores-previne-brasil/resultado/quadrimestre/' +
            this.quadrimestre
        )
        if (response) {
          this.dados = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    async buscarPorQuadrimestre(event) {
      this.quadrimestre = event.target.value
      try {
        this.loading = true
        let url = ''
        if (this.estado == '') {
          url =
            '/serie-historica/indicadores-previne-brasil/resultado/quadrimestre/' +
            this.quadrimestre
        } else {
          url =
            '/serie-historica/indicadores-previne-brasil/resultado/estado/' +
            this.estado +
            '/quadrimestre/' +
            this.quadrimestre
        }
        let response = await this.$apiPublic.get(url)
        if (response) {
          this.dados = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    async buscarPorEstado(event) {
      this.estado = event.target.value
      this.temEstadoSelecionado = true
      try {
        this.loading = true
        let url = ''
        if (this.quadrimestre == '') {
          url =
            '/serie-historica/indicadores-previne-brasil/resultado/estado/' +
            this.estado
        } else {
          url =
            '/serie-historica/indicadores-previne-brasil/resultado/estado/' +
            this.estado +
            '/quadrimestre/' +
            this.quadrimestre
        }
        let response = await this.$apiPublic.get(url)
        if (response) {
          this.dados = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    modalSeloAps(item, indice) {
      let porcentagem = (parseFloat(item.isf) * 10).toFixed(2)
      this.seloApsImg = ''
      let posicao_brasil = ''
      let posicao_estado = ''
      if (this.estado == '') {
        posicao_brasil = indice
      } else {
        posicao_estado = indice
      }
      this.seloApsImg = `https://esusfeedback.com.br/api/seloAPS.php?municipio=${item.municipio}&uf=${item.uf}&isf=${item.isf}&porcentagem=${porcentagem}&quadrimestre=${item.quadrimestre}&media=${item.media}&posicao_br=${posicao_brasil}&posicao_estado=${posicao_estado}&tipo=selo-aps`
      this.openedModalSeloAps = true
    },

    async modalPorcentagem(item) {
      this.openedModalPorcentagem = true
      this.municipio = item
      // limpa o gráfico inicialmente
      this.$refs.chartData.updateSeries([])
      try {
        let response = await this.$apiPublic.get(
          '/serie-historica/indicadores-previne-brasil/resultado/municipio/' +
            item.co_ibge
        )
        if (response) {
          let response2 = response.data
          let quadrimestre_atual = response2.find((el) => {
            return el.quadrimestre == this.quadrimestre
          })
          let quadrimestre_anterior = {
            quadrimestre: '',
          }

          for (let i = 0; i < response2.length; i++) {
            if (response2[i].quadrimestre === quadrimestre_atual.quadrimestre) {
              quadrimestre_anterior = response2[i - 1]
            }
          }

          let isf_atual = quadrimestre_atual.isf
          let isf_anterior = quadrimestre_anterior.isf

          this.porcentagemImg = `https://esusfeedback.com.br/api/seloAPS.php?municipio=${item.municipio}&uf=${item.uf}&isf_atual=${isf_atual}&isf_anterior=${isf_anterior}&quadrimestre_atual=${quadrimestre_atual.quadrimestre}&quadrimestre_anterior=${quadrimestre_anterior.quadrimestre}&tipo=porcentagem`
          this.openedModalPorcentagem = true
        }
      } catch (error) {
        console.log(error)
      }
    },

    downloadSeloAps(seloApsImg) {
      window.open(`${seloApsImg}&download=true`, '_blank')
    },

    downloadImgPorcentagem(porcentagemImg) {
      window.open(`${porcentagemImg}&download=true`, '_blank')
    },

    resetarFiltros() {
      this.estado = ''
      this.nomeMunicipio = ''
      this.temEstadoSelecionado = false
      this.buscarDados()
    },

    changeFontColor(isf) {
      if (isf < 4) {
        return 'sh-re-button-isf-red'
      } else if (isf >= 4 && isf < 7) {
        return 'sh-re-button-isf-orange'
      } else if (isf >= 7 && isf <= 9) {
        return 'sh-re-button-isf-green'
      } else if (isf > 9) {
        return 'sh-re-button-isf-blue'
      } else {
        return ''
      }
    },

    gerarPdf() {
      this.loading = true
      this.loadingPdf = true
      let info = ''
      if (this.estado === '') {
        info = 'BRASIL'
      } else {
        info = this.estado
      }
      let title_pdf = 'Ranking Resultado Previne Brasil'
      let headers_pdf = [
        'MUNICÍPIO',
        'I1',
        'I2',
        'I3',
        'I4',
        'I5',
        'I6',
        'I7',
        'ISF',
        'DESEMPENHO',
      ]
      var data_pdf = []
      for (let i = 0; i < this.displayedCadastros.length; i++) {
        var obj = {}
        obj.municipio = `${i + 1}° ${this.displayedCadastros[i].municipio} - ${
          this.displayedCadastros[i].uf
        }`
        obj.i1 = this.displayedCadastros[i].pn_6_consultas
        obj.i2 = this.displayedCadastros[i].pn_hiv_sifilis
        obj.i3 = this.displayedCadastros[i].pn_odontologia
        obj.i4 = this.displayedCadastros[i].citopatologico
        obj.i5 = this.displayedCadastros[i].crianca_polio_penta
        obj.i6 = this.displayedCadastros[i].pa_hipertensao
        obj.i7 = this.displayedCadastros[i].hg_diabetes
        obj.isf = this.displayedCadastros[i].isf
        obj.desempenho = this.displayedCadastros[i].media
        data_pdf.push(obj)
      }
      let doc = new jsPDF()
      let rows = []
      for (let i = 0; i < data_pdf.length; i++) {
        rows[i] = Object.values(data_pdf[i])
      }
      let table = []
      for (var i = 0; i < rows.length; i++) {
        var tableRow = rows[i]
        for (var i = 0; i < rows.length; i++) {
          var tableRow = rows[i]
          var rowData = []
          if (tableRow.length != 0) {
            for (var j = 0; j < tableRow.length; j++) {
              rowData.push(tableRow[j])
            }
          } else {
            continue
          }
          table.push(rowData)
        }
      }
      doc.setFontSize(14)
      doc.text(info, 105, 20, null, null, 'center')
      doc.setFontSize(14)
      doc.text(title_pdf, 105, 27, null, null, 'center')
      doc.setFontSize(14)
      doc.text(
        'Quadrimestre ' + this.quadrimestre,
        105,
        34,
        null,
        null,
        'center'
      )

      // Data atual
      let data = new Date()
      let dia = String(data.getDate()).padStart(2, '0')
      let mes = String(data.getMonth() + 1).padStart(2, '0')
      let ano = data.getFullYear()
      let dataAtual = dia + '/' + mes + '/' + ano
      doc.setFontSize(14)
      doc.text('Gerado em: ' + dataAtual, 105, 41, null, null, 'center')

      doc.autoTable({
        html: '#table',
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        columnStyles: {
          1: { halign: 'left' },
        },
        theme: 'striped',
        startY: 52,
        showHead: 'firstPage',
        // Chamado antes de uma célula ou linha ser desenhada. Pode ser usado para chamar funções de estilo jspdf nativas, como doc.setTextColor alterar a posição do texto, etc., antes de ser desenhado.
        willDrawCell: function (data) {
          // pula a coluna "TEM"
          if (data.column.index === 0) {
            return false
          }
          // formata o nome do municipio
          if (data.column.index === 1 && data.cell.section === 'body') {
            const text = data.cell.text[0]
            if (text !== undefined) {
              let text = `${data.cell.text[0].replace(
                'Gráfico IndicadoresGráfico ISFDesempenhoEvolução',
                ''
              )}`
              if (data.cell.text[1] !== undefined) {
                text += ` ${data.cell.text[1]}`
              }
              data.cell.text = text
            }
          }
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
          }
          // if (data.cell.section === 'body') {
          // let i1 = data.row.raw[2]
          // let className = i1._element.className
          // console.log(i1)
          // let color = ''
          // if (className.includes('red')) {
          //   color = 'red'
          // }
          // if (className.includes('orange')) {
          //   color = 'orange'
          // }
          // if (className.includes('green')) {
          //   color = 'green'
          // }
          // if (className.includes('blue')) {
          //   color = 'blue'
          // }
          // doc.setTextColor(color)
          // }
        },
      })

      doc.save(title_pdf + '.pdf')
      this.loadingPdf = false
      this.loading = false
    },
  },
}
</script>

<style>
.sh-ri-header {
  width: 100%;
  border-bottom: 1px solid #eeeeee;
  padding: 15px 0;
  margin-bottom: 30px;
}
.sh-ri-header .container {
  max-width: 85vw !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.sh-ri-header .logo img {
  width: 160px;
}

.sh-ri-header .titulo {
  width: 100%;
  padding: 20px 0;
}

.sh-ri-header .titulo h1 {
  font-size: 25px;
  text-align: center;
}

.sh-ri-content .container {
  max-width: 85vw !important;
}

.modal-sh .modal-container {
  width: 1050px;
}

.modal-sh .apexcharts-legend.position-top.apexcharts-align-center {
  justify-content: center;
}

.sh-ri-info {
  background-color: #fff;
  padding: 15px;
  margin-bottom: 10px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.sh-ri-info h3 {
  font-size: 17px;
}

.sh-ri-percent {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: 500;
}

.sh-ri-percent > div {
  margin: 0 10px;
}

.sh-ri-percent > div:first-child {
  margin-left: 0;
}

.sh-ri-percent span {
  width: 25px;
  height: 20px;
  display: inline-block;
  vertical-align: middle;
  border-radius: 4px;
}

.sh-ri-percent-red span {
  background-color: red;
}

.sh-ri-percent-orange span {
  background-color: orange;
}

.sh-ri-percent-green span {
  background-color: green;
}

.sh-ri-percent-blue span {
  background-color: blue;
}

.sh-re-button-isf {
  padding: 0 10px;
  cursor: pointer;
  font-weight: 700;
}

.sh-ri-percent-red,
.sh-re-button-isf-red {
  color: red;
}

.sh-ri-percent-orange,
.sh-re-button-isf-orange {
  color: orange;
}

.sh-ri-percent-green,
.sh-re-button-isf-green {
  color: green;
}

.sh-ri-percent-blue,
.sh-re-button-isf-blue {
  color: blue;
}

.sh-ri .table .thead-light th,
.sh-ri .table tbody td {
  text-align: center;
}

.sh-ri table thead th:hover {
  cursor: pointer;
  background-color: #ccc;
}

.sh-ri table tbody tr td {
  font-size: 14px !important;
}

.sh-ri table tbody tr td .placement {
  margin-right: 15px;
  font-weight: 700;
  display: inline-block;
}

.sh-ri .btn.btn-default {
  color: #333;
  background-color: #ebebeb;
  border-color: #adadad;
  box-shadow: inset 0 3px 5px rgb(0 0 0 / 13%);
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.428571429;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 0px;
  height: 38px;
}

/* .rh-si-icon-grafico{
        padding: 5px 15px;
    } */

.rh-si-icon-grafico img {
  width: 30px;
  cursor: pointer;
}

.selo-aps-img {
  cursor: pointer;
}

.modal-selo-aps img {
  width: 100%;
}

.modal-selo-aps-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sh-ri footer h3 {
  text-align: center;
}

.sh-ri footer a img {
  margin: 25px auto;
  display: table;
  width: 150px;
}

.sh-ri footer p {
  text-align: center;
}

.sh-ri .tem-logo {
  display: flex;
  align-items: center;
  justify-content: center;
}

.sh-ri .btn-options button {
  background: transparent;
  border: navajowhite;
  box-shadow: none;
  color: #000;
}

@media screen and (max-width: 656px) {
  .sh-ri-header .container {
    max-width: 100vw !important;
  }
  .sh-ri-content .container {
    max-width: 100vw !important;
  }
  .sh-ri-header .logo img {
    width: 45px !important;
  }
  .sh-ri-header .titulo h1 {
    font-size: 15px;
    text-align: center;
  }
  .modal-sh .modal-container {
    width: 100%;
  }
  .sh-ri-info {
    margin-top: 15px;
  }
}

@media screen and (min-width: 657px) and (max-width: 807px) {
  .sh-ri-header .container {
    max-width: 100vw !important;
  }
  .sh-ri-content .container {
    max-width: 100vw !important;
  }
  .sh-ri-header .logo img {
    width: 45px !important;
  }
  .sh-ri-header .titulo h1 {
    font-size: 15px;
    text-align: center;
  }
  .modal-sh .modal-container {
    width: 100%;
  }
  .sh-ri-info {
    margin-top: 15px;
  }
}

@media screen and (min-width: 808px) and (max-width: 1023px) {
  .sh-ri-header .container {
    max-width: 100vw !important;
  }
  .sh-ri-content .container {
    max-width: 100vw !important;
  }
  .sh-ri-header .logo img {
    width: 45px !important;
  }
  .sh-ri-header .titulo h1 {
    font-size: 15px;
    text-align: center;
  }
  .modal-sh .modal-container {
    width: 100%;
  }
  .sh-ri-info {
    margin-top: 15px;
  }
}

@media screen and (min-width: 1024px) and (max-width: 1265px) {
  .sh-ri-header .container {
    max-width: 100vw !important;
  }
  .sh-ri-content .container {
    max-width: 100vw !important;
  }
  .sh-ri-header .logo img {
    width: 45px !important;
  }
  .sh-ri-header .titulo h1 {
    font-size: 15px;
    text-align: center;
  }
  .modal-sh .modal-container {
    width: 100%;
  }
  .sh-ri-info {
    margin-top: 15px;
  }
}
</style>
<style scoped>
.section-title-index {
  display: flex;
  align-items: center;
  gap: 1%;
  padding: 0;
  margin: 0;
  border-top: 0;
  padding-bottom: 10px;
  margin-bottom: 20px;
  border-bottom: 3px solid #eee;
  font-size: 18px;
  color: #000;
  font-weight: 600;
  position: relative;
}
.section-title-index::before {
  content: '';
  display: block;
  width: 50px;
  height: 3px;
  background-color: #0d98bb;
  position: absolute;
  bottom: -3px;
  left: 0;
}
.pdf-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.pdf-container .spinner {
  margin-right: 20px;
  color: #0fafd7;
}
</style>
<style src="./styles.scss" scoped lang="scss" />
